import React from 'react'
import GridList from '../../../GridList'
import { DeleteIcon, ChatIcon } from 'images/common'
import './AskVisoGrid.scss'

const AskVisoGrid = ({ color, data, title, onConversationClick, onDeleteClick, deleteLoading, isFullscreen }) => {

  return (
    <div className='ask-viso-grid'>
      <div className='ask-viso-grid__title viso-text-label'>{title}</div>
      <div className='ask-viso-grid__data'>
        <GridList
          gridDefs={[
            {
              column: 'name',
              label: 'Name',
              truncate: isFullscreen ? 90 : 55
            }
          ]}
          gridData={data}
          gridProps={{
            hideHead: true,
            disableMobile: true,
            color: color,
            rowProps: {
              rowClick: (item) => deleteLoading ? null : onConversationClick(item._id, item),
              rowIcon: <ChatIcon />,
              rowBlank: data.length === 0 && 'No history available',
              rowActions: [{
                label: 'Delete',
                icon: <DeleteIcon />,
                onClick: (item) => deleteLoading ? null : onDeleteClick(item._id),
                disabled: deleteLoading
              }]
            }
          }}
        />
      </div>
    </div>
  )
}

export default AskVisoGrid